import { styled } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";

export const StyledWrapper: any = styled("div")(({ theme }: { theme: Theme }) => {
  const baseFontSize = theme.typography?.fontSize;
  const fontFamily = theme.typography?.fontFamily;
  return {
    
    ".bc-small-text": {
      fontSize: baseFontSize && baseFontSize - 4,
      fontWeight: theme.settings?.fonts?.fontWeight,
    },
    ".bc-medium-text": {
      fontSize: baseFontSize,
      fontWeight: theme.settings?.fonts?.fontWeight,
    },
    ".bc-medium-adjust-text": {
      fontSize: baseFontSize,
      fontWeight: theme.settings?.fonts?.fontWeight,
      "@media (max-width: 900px)": {
        fontSize: baseFontSize && baseFontSize - 2,
      },
    },
    ".bc-large-adjust-text": {
      fontSize: baseFontSize && baseFontSize + 4,
      fontWeight: theme.settings?.fonts?.fontWeight,
      "@media (max-width: 900px)": {
        fontSize: baseFontSize && baseFontSize - 2,
      },
    },
    ".styled-dialog-content": {
      ".subtitle": {
        fontSize: baseFontSize && baseFontSize - 2,
      },
      ".title": {
        fontSize: baseFontSize && baseFontSize + 8,
      },
      ".platform-title": {
        fontSize: baseFontSize,
      },
    },
    ".dtc-modal": {
      ".retailer_price": {
        ".header": {
          fontSize: baseFontSize && baseFontSize + 8 + "px !important",
        },
        ".name": {
          fontSize: baseFontSize && baseFontSize - 2 + "px !important",
        },
        ".bc-dtc-price": {
          fontSize: baseFontSize && baseFontSize + 6 + "px !important",
        },
      },
      "& .MuiButtonBase-root": {
        fontSize: baseFontSize && `${baseFontSize - 2}px !important`,
      },
    },
  };
});
